import { render, staticRenderFns } from "./ReturnDepot.vue?vue&type=template&id=b2b560fa&"
import script from "./ReturnDepot.vue?vue&type=script&lang=js&"
export * from "./ReturnDepot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports